var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFruits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_690_5034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 19.5883C9.91667 22.3767 11.06 25.3633 12.9033 27.37C11.7717 27.79 10.5467 28 9.275 28C4.13 28 0.093338 24.4533 0.093338 19.9383C0.093338 18.235 0.641671 16.6133 1.68 15.225C1.70334 15.2017 1.715 15.1783 1.73834 15.1667C3.89667 12.1567 3.92 9.695 3.92 9.60167C3.92 6.87167 6.32334 4.66667 9.275 4.66667C12.2383 4.66667 14.63 6.87167 14.63 9.57834C14.63 9.75334 14.6533 10.885 15.3417 12.53C11.9817 13.3583 9.91667 15.9483 9.91667 19.5883Z",
    fill: "#A76BA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0C10.7835 0 8.16664 2.61683 8.16664 5.83333C8.16664 6.4785 8.68814 7 9.33331 7C9.97847 7 10.5 6.4785 10.5 5.83333C10.5 3.90367 12.0703 2.33333 14 2.33333C14.6451 2.33333 15.1666 1.81183 15.1666 1.16667C15.1666 0.5215 14.6451 0 14 0Z",
    fill: "#A76BA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 9.33333C21.2835 9.33333 18.6666 11.9502 18.6666 15.1667C18.6666 15.8118 19.1881 16.3333 19.8333 16.3333C20.4785 16.3333 21 15.8118 21 15.1667C21 13.237 22.5703 11.6667 24.5 11.6667C25.1451 11.6667 25.6666 11.1452 25.6666 10.5C25.6666 9.85483 25.1451 9.33333 24.5 9.33333Z",
    fill: "#A76BA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8761 14C21.1715 14 20.4866 14.133 19.8333 14.3978C19.18 14.133 18.4951 14 17.7905 14C13.9556 14 11.6666 16.0883 11.6666 19.586C11.6666 23.4768 14.3418 28 17.7905 28C18.4951 28 19.18 27.867 19.8321 27.601C20.4878 27.867 21.1726 28 21.8761 28C25.3248 28 28 23.4768 28 19.586C28 16.0883 25.711 14 21.8761 14Z",
    fill: "#A76BA1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_690_5034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFruits);
export default __webpack_public_path__ + "static/media/fruits.294cacd11a507ad0ec332212310ded43.svg";
export { ForwardRef as ReactComponent };